<template>
  <div class="alumni-personal">
    <div class="page-body">
      <div class="form-card">
        <div class="section-head">
          <span class="section-bar" />
          <span class="section-title">基本信息</span>
          <div class="section-link" @click="goList">
            <span>查看个人信息表</span>
            <van-icon name="arrow" class="link-arrow" />
          </div>
        </div>

        <van-form ref="formRef">
          <div class="field-block">
            <label class="field-label"><span class="req">*</span>姓名</label>
            <van-field
              v-model="form.fullName"
              name="fullName"
              placeholder="请输入姓名"
              class="input-like"
              maxlength="50"
              :rules="[{ required: true, message: '请输入姓名' }]"
            />
          </div>

          <div class="field-block">
            <label class="field-label"><span class="req">*</span>籍贯</label>
            <van-field
              v-model="form.nativePlace"
              name="nativePlace"
              readonly
              clickable
              placeholder="请选择籍贯信息"
              class="input-like"
              right-icon="arrow"
              :rules="[{ required: true, message: '请选择籍贯信息' }]"
              @click="showNative = true"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>现任单位</label
            >
            <van-field
              v-model="form.currentUnit"
              name="currentUnit"
              placeholder="请输入现任单位"
              class="input-like"
              maxlength="100"
              :rules="[{ required: true, message: '请输入现任单位' }]"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>现任岗位</label
            >
            <van-field
              v-model="form.currentPosition"
              name="currentPosition"
              placeholder="请输入现任岗位"
              class="input-like"
              maxlength="50"
              :rules="[{ required: true, message: '请输入现任岗位' }]"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>联系电话</label
            >
            <van-field
              v-model="form.contactInfo"
              name="contactInfo"
              type="tel"
              placeholder="请输入联系电话"
              class="input-like"
              maxlength="11"
              :rules="[
                { required: true, message: '请输入联系电话' },
                { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' },
              ]"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>电子邮箱</label
            >
            <van-field
              v-model="form.email"
              name="email"
              placeholder="请输入电子邮箱"
              class="input-like"
              maxlength="80"
              :rules="[
                { required: true, message: '请输入电子邮箱' },
                {
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: '请输入正确的电子邮箱',
                },
              ]"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>毕业年份</label
            >
            <van-field
              v-model="form.graduationYear"
              name="graduationYear"
              readonly
              clickable
              placeholder="请选择"
              class="input-like"
              right-icon="arrow"
              :rules="[{ required: true, message: '请选择毕业年份' }]"
              @click="showYear = true"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>所在院系</label
            >
            <van-field
              v-model="form.department"
              name="department"
              placeholder="请输入所在院系"
              class="input-like"
              maxlength="100"
              :rules="[{ required: true, message: '请输入所在院系' }]"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>所在专业</label
            >
            <van-field
              v-model="form.major"
              name="major"
              placeholder="请输入所在专业"
              class="input-like"
              maxlength="80"
              :rules="[{ required: true, message: '请输入所在专业' }]"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>现居地址</label
            >
            <van-field
              v-model="form.currentAddress"
              name="currentAddress"
              placeholder="请输入现居地址"
              class="input-like"
              maxlength="200"
              :rules="[{ required: true, message: '请输入现居地址' }]"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>是否愿意参加校友会</label
            >
            <div class="radio-row">
              <div
                :class="[
                  'radio-box',
                  form.willingParticipate == '1' ? 'radio-box--on' : '',
                ]"
                @click="form.willingParticipate = '1'"
              >
                <span>是</span>
                <span v-if="form.willingParticipate == '1'" class="radio-dot">
                  <van-icon name="success" color="#fff" size="12" />
                </span>
                <span v-else class="radio-empty" />
              </div>
              <div
                :class="[
                  'radio-box',
                  form.willingParticipate == '0' ? 'radio-box--on' : '',
                ]"
                @click="form.willingParticipate = '0'"
              >
                <span>否</span>
                <span v-if="form.willingParticipate == '0'" class="radio-dot">
                  <van-icon name="success" color="#fff" size="12" />
                </span>
                <span v-else class="radio-empty" />
              </div>
            </div>
          </div>

          <div class="field-block">
            <label class="field-label">推荐老师或校友</label>
            <van-field
              v-model="form.peerAlumniName"
              name="peerAlumniName"
              placeholder="请输入姓名"
              class="input-like"
              maxlength="50"
            />
          </div>

          <div class="field-block">
            <label class="field-label">联系方式</label>
            <van-field
              v-model="form.peerAlumniContact"
              name="peerAlumniContact"
              placeholder="请输入联系方式"
              class="input-like"
              maxlength="50"
            />
          </div>

          <div class="field-block">
            <label class="field-label">校友寄语</label>
            <van-field
              v-model="form.alumniMessage"
              name="alumniMessage"
              type="textarea"
              rows="4"
              autosize
              placeholder="请输入"
              class="input-like input-like--textarea"
              maxlength="500"
              show-word-limit
            />
          </div>

          <div class="submit-wrap safe-bottom">
            <van-button
              block
              type="primary"
              class="submit-btn"
              native-type="submit"
              :loading="submitting"
              @click="validate"
            >
              提交
            </van-button>
          </div>
        </van-form>
      </div>
    </div>

    <van-popup v-model="showNative" position="bottom" round>
      <van-cascader
        v-model="nativeCascaderVal"
        title="请选择籍贯"
        :options="regionOptions"
        @close="showNative = false"
        @finish="onNativeFinish"
      />
    </van-popup>

    <van-popup v-model="showYear" position="bottom" round>
      <van-picker
        show-toolbar
        title="毕业年份"
        :columns="yearColumns"
        @confirm="onYearConfirm"
        @cancel="showYear = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { getResRegionTree } from "@/api/resource/resregion";
import { addAlumniPersonal, getAlumniPersonalDetail } from "@/api/cms/alumni";
import { Toast } from "vant";
export default {
  name: "AlumniPersonalForm",
  data() {
    const y = new Date().getFullYear();
    const yearColumns = [];
    for (let i = y + 1; i >= 1950; i--) {
      yearColumns.push(String(i));
    }
    return {
      submitting: false,
      showNative: false,
      showYear: false,
      nativeCascaderVal: "",
      regionOptions: [],
      yearColumns,
      form: {
        fullName: "",
        nativePlace: "",
        currentUnit: "",
        currentPosition: "",
        contactInfo: "",
        email: "",
        graduationYear: "",
        department: "",
        major: "",
        currentAddress: "",
        willingParticipate: "1",
        peerAlumniName: "",
        peerAlumniContact: "",
        alumniMessage: "",
      },
    };
  },
  created() {
    this.getAlumniPersonalDetailFn();
    this.getResRegionTreeFn();
  },
  methods: {
    getAlumniPersonalDetailFn() {
      if (!this.$route.query.id) {
        return;
      }
      getAlumniPersonalDetail(this.$route.query.id).then((res) => {
        this.form = res.data;
        this.nativeCascaderVal = res.data.districtCode;
      });
    },
    getResRegionTreeFn() {
      getResRegionTree({ maxType: 2 }).then((res) => {
        // 递归删除children为空或者children为空数组的对象
        const filterChildren = (data) => {
          return data.map((item) => {
            item.text = item.name;
            item.value = item.code;
            if (item.children && item.children.length > 0) {
              item.children = filterChildren(item.children);
            } else {
              delete item.children;
            }
            return item;
          });
        };
        let array = filterChildren(res.data);

        this.regionOptions = JSON.parse(JSON.stringify(array));
      });
    },
    onBack() {
      if (this.$router && window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.replace({ name: "AlumniSelect" });
      }
    },
    goList() {
      this.$router.push({ name: "AlumniPersonalList" });
    },
    onNativeFinish({ selectedOptions }) {
      console.log(this.nativeCascaderVal);
      this.form.nativePlace = selectedOptions.map((o) => o.text).join(" / ");
      this.form.provinceCode = selectedOptions[0].code;
      this.form.cityCode = selectedOptions[1].code;
      this.form.districtCode = selectedOptions[2].code;
      this.form.provinceName = selectedOptions[0].name;
      this.form.cityName = selectedOptions[1].name;
      this.form.districtName = selectedOptions[2].name;
      this.showNative = false;
      // this.clearErr("nativePlace");
    },
    onYearConfirm(value) {
      this.form.graduationYear = Array.isArray(value) ? value[0] : value;
      this.showYear = false;
      this.clearErr("graduationYear");
    },
    clearErr(key) {
      this.$delete(this.errors, key);
    },
    onSubmit() {
      // console.log(JSON.parse(JSON.stringify(this.form)));
      addAlumniPersonal(JSON.parse(JSON.stringify(this.form)))
        .then(() => {
          if (this.form.id) {
            Toast.success("更新成功");
          } else {
            Toast.success("提交成功");
          }
          setTimeout(() => {
            this.submitting = false;
            this.$router.push({ path: "/alumni/personal/list" });
          }, 1000);
        })
        .catch(() => {
          this.submitting = false;
        });
    },

    async validate() {
      this.submitting = true;
      try {
        await this.$refs.formRef.validate();
        this.onSubmit();
      } catch (error) {
        this.submitting = false;
        // 跳转到第一个错误项
        this.$refs.formRef.scrollToField(error[0].name);

        // Toast.fail("请完善表单信息");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$primary: #2d6cf6;

.alumni-personal {
  min-height: 100vh;
  background: #f0f2f5;
}

.alumni-nav {
  ::v-deep .van-nav-bar {
    background: $primary;
  }
  ::v-deep .van-nav-bar__title {
    color: #fff;
    font-weight: 600;
    font-size: 17px;
  }
  ::v-deep .van-nav-bar__content {
    height: 46px;
  }
}

.page-body {
  padding: 12px 12px 24px;
}

.form-card {
  background: #fff;
  border-radius: 16px 16px 0 0;
  padding: 16px 14px 8px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.04);
}

.section-head {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  flex-wrap: wrap;
  gap: 8px;
}

.section-bar {
  width: 4px;
  height: 16px;
  background: $primary;
  border-radius: 2px;
  margin-right: 8px;
}

.section-title {
  flex: 1;
  font-size: 16px;
  font-weight: 700;
  color: #333;
  min-width: 0;
}

.section-link {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  color: $primary;
  white-space: nowrap;
}

.link-arrow {
  font-size: 14px;
  margin-left: 2px;
}

.field-block {
  margin-bottom: 16px;
}

.field-label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  font-weight: 500;
}

.req {
  color: #ee0a24;
  margin-right: 2px;
}

.input-like {
  // background: #f7f8fa;
  border-radius: 8px;
  padding: 10px 12px !important;

  ::v-deep .van-field__control {
    font-size: 15px;
    color: #333;

    &::placeholder {
      color: #bbb;
    }
  }

  ::v-deep .van-field__error-message {
    margin-top: 6px;
  }
}

.input-like--textarea {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.radio-row {
  display: flex;
  gap: 12px;
}

.radio-box {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 12px;
  background: #f7f8fa;
  border-radius: 8px;
  font-size: 15px;
  color: #333;
  border: 1px solid transparent;
}

.radio-box--on {
  background: #f0f5ff;
  border-color: rgba(45, 108, 246, 0.35);
}

.radio-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: $primary;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.radio-empty {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.err-msg {
  margin: 8px 0 0;
  font-size: 12px;
  color: #ee0a24;
}

.submit-wrap {
  padding: 24px 2px 8px;
}

.safe-bottom {
  padding-bottom: max(16px, env(safe-area-inset-bottom, 16px));
}

.submit-btn {
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  background: $primary;
  border: none;
}
</style>
